import * as Yup from "yup";
import { validatorName } from "../../../../shared/validators/validatorName";
import { validatorTaxId } from "../../../../shared/validators/validatorTaxId";

export const validationSchemaUsPersonInfo = Yup.object().shape({
  ssn: validatorTaxId("ssn", "Individual", "US").required("Required"),
  firstName: validatorName.required("Required"),
  middleName: validatorName,
  lastName: validatorName.required("Required"),
  usPersonSince: Yup.string().oneOf(["always", "date"]).required("Required"),
  usPersonDate: Yup.date()
    .nullable()
    .when("usPersonSince", {
      is: "date",
      then: Yup.date().nullable().required("Date is required")
    })
});
